<template >
    <div page-card>
        <h2 v-if="orderInformation.type === 'Благоустройство могил'" class="order-information__title">Наряд-заказ на благоустройство могилы <b>{{ orderInformation.number }}</b></h2>
        <h2 v-if="orderInformation.type === 'Памятник'" class="order-information__title">Наряд-заказ на гранитное изделие <b>{{ orderInformation.number }} {{ orderInformation.letter }}</b></h2>
        <span class="order-information__master">
            <span>Создатель заказа</span>
            <span>{{ orderInformation.creatorContacts?.fullname }}</span>
        </span>
        <div class="order-information__edit-buttons">
            <button-component class="order__editing" button-text="Редактировать" v-if="role !== UserRole.USER && role !== UserRole.MANAGER" iconName="pencil" @click="router.push({name: 'edit', params: { orderId: order._id }})"/>
            <order-file-component :order="order" class="order__editing_pdf"/>
        </div>
        <div class="order-information__form">
            <div class="order-information__item information">
                <h3 class="order-information__title_min">Даты заказа</h3>
                <div class="information__list">
                    <div class="information__item">
                        <span class="information__title">Дата заключения договора</span>
                        <span class="information__text">{{orderInformation.createdAt ? new Date(orderInformation.createdAt).toLocaleDateString() : 'не указано'}}</span>
                    </div>
                    <div class="information__item">
                        <span class="information__title">Дата закрытия договора</span>
                        <span class="information__text">{{orderInformation.closedAt ? new Date(orderInformation.closedAt).toLocaleDateString() : 'не указано'}}</span>
                    </div>
                </div>
            </div>
            <div class="order-information__item information">
                <h3 class="order-information__title_min">Контактная информация</h3>
                <div class="information__list">
                    <div class="information__item" v-if="orderInformation.information.client">
                        <span class="information__title">Ф.И.О. заказчика</span>
                        <span class="information__text">{{orderInformation.information.client}}</span>
                    </div>
                    <div class="information__item" v-if="orderInformation.information.clientPhone">
                        <span class="information__title">Номер телефона</span>
                        <a :href="`tel:${orderInformation.information.clientPhone}`" class="information__text">{{orderInformation.information.clientPhone}}</a>
                    </div>
                    <div class="information__item" v-if="orderInformation.information.clientAddress">
                        <span class="information__title">Адрес</span>
                        <span class="information__text">{{orderInformation.information.clientAddress}}</span>
                    </div>
                    <div class="information__item" v-if="orderInformation.information.clientEmail">
                        <span class="information__title">Email</span>
                        <a :href="`mailto:${orderInformation.information.clientEmail}`" class="information__text">{{orderInformation.information.clientEmail}}</a>
                    </div>
                </div>
            </div>
            <div class="order-information__item information">
                <h3 class="order-information__title_min">Информация о покойном</h3>
                <div class="information__list">
                    <div class="information__item" v-if="orderInformation.information.deceased">
                        <span class="information__title">Ф.И.О. покойного</span>
                        <span class="information__text">{{orderInformation.information.deceased}}</span>
                    </div>
                    <div class="information__item" v-if="orderInformation.information.cemetery">
                        <span class="information__title">Дата рождения</span>
                        <span class="information__text">{{orderInformation.information.birthDate ? new Date(orderInformation.information.birthDate).toLocaleDateString() : 'не указано'}}</span>
                    </div>
                    <div class="information__item" v-if="orderInformation.information.cemetery">
                        <span class="information__title">Дата смерти</span>
                        <span class="information__text">{{orderInformation.information.deathDate ? new Date(orderInformation.information.deathDate).toLocaleDateString() : 'не указано'}}</span>
                    </div>
                    <div class="information__item" v-if="orderInformation.information.cemetery">
                        <span class="information__title">Место установки</span>
                        <span class="information__text">{{orderInformation.information.cemetery}}</span>
                    </div>
                    <div class="information__list_sub">
                        <div class="information__item" v-if="orderInformation.information.graveDistrict">
                            <span class="information__title">Участок</span>
                            <span class="information__text">{{orderInformation.information.graveDistrict}}</span>
                        </div>
                        <div class="information__item" v-if="orderInformation.information.graveRow">
                            <span class="information__title">Ряд</span>
                            <span class="information__text">{{orderInformation.information.graveRow}}</span>
                        </div>
                        <div class="information__item" v-if="orderInformation.information.gravePlace">
                            <span class="information__title">Место</span>
                            <span class="information__text">{{orderInformation.information.gravePlace}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="orderInformation.type === 'Благоустройство могил'" class="order-information__item service">
                <h3 class="order-information__title_min">Список оказываемых услуг</h3>
                <div class="service__list">
                    <div class="service__item info" v-for="service, index in orderInformation.services" :key="service.title">
                        <div class="information__item">
                            <span class="information__title">Наименование услуги</span>
                            <span class="information__text">{{service.title}}</span>
                        </div>
                        <div class="information__item">
                            <span class="information__title">Размер</span>
                            <span class="information__text">{{service.quantity}}</span>
                        </div>
                        <div class="information__item">
                            <span class="information__title">Ед. изм.</span>
                            <span class="information__text">{{service.measurement}}</span>
                        </div>
                        <div class="information__item">
                            <span class="information__title">Цена за ед., руб.</span>
                            <span class="information__text">{{service.cost}}</span>
                        </div>
                        <div class="information__item">
                            <span class="information__title">Сумма, руб.</span>
                            <span class="information__text">{{service.price}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="orderInformation.type === 'Памятник'" class="order-information__item service">
                <h3 class="order-information__title_min">Список оказываемых услуг</h3>
                <div v-for="servicesType, key in servicesTypes" :key="servicesType">
                    <div class="create-order__service-devider">
                        <span>{{servicesType}}</span>
                        <span>{{getCurrentTypePrice(servicesType)}} руб.</span>
                    </div>
                    <div class="service__list">
                        <div class="service__item info" v-for="service, index in getCurrentServiceType(servicesType)" :key="service.title">
                            <div v-if="service.title === 'Памятник'">
                                <div class="information__item">
                                    <span class="information__title">Наименование услуги</span>
                                    <span class="information__text">{{service.title}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Цвет</span>
                                    <span class="information__text">{{service.color}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Номер памятника в каталоге</span>
                                    <span class="information__text">{{service.monumentNumber}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Размер</span>
                                    <span class="information__text">{{service.size}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Полировка</span>
                                    <span class="information__text">{{service.polish}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Цена</span>
                                    <span class="information__text">{{service.price}}</span>
                                </div>
                            </div>
                            <div v-if="service.title === 'Подставка' || service.title === 'Цветник' || service.title === 'Надгробная плита'">
                                <div class="information__item">
                                    <span class="information__title">Наименование услуги</span>
                                    <span class="information__text">{{service.title}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Цвет</span>
                                    <span class="information__text">{{service.color}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Размер</span>
                                    <span class="information__text">{{service.size}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Полировка</span>
                                    <span class="information__text">{{service.polish}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Цена</span>
                                    <span class="information__text">{{service.price}}</span>
                                </div>
                            </div>
                            <div v-if="service.title === 'Ваза' || service.title === 'Подсвечник' || service.title === 'Фото ниша под керамогранит'">
                                <div class="information__item">
                                    <span class="information__title">Наименование услуги</span>
                                    <span class="information__text">{{service.title}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Количество</span>
                                    <span class="information__text">{{service.quantity}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Размер</span>
                                    <span class="information__text">{{service.size}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Цена</span>
                                    <span class="information__text">{{service.price}}</span>
                                </div>
                            </div>
                            <div v-if="service.title === 'Техническое отверстие'">
                                <div class="information__item">
                                    <span class="information__title">Наименование услуги</span>
                                    <span class="information__text">{{service.title}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Количество</span>
                                    <span class="information__text">{{service.quantity}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Цена</span>
                                    <span class="information__text">{{service.price}}</span>
                                </div>
                            </div>
                            <div v-if="service.title === 'Фаска'">
                                <div class="information__item">
                                    <span class="information__title">Наименование услуги</span>
                                    <span class="information__text">{{service.title}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Тип фаски</span>
                                    <span class="information__text">{{service.chamfer}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Полировка</span>
                                    <span class="information__text">{{service.polish}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Цена</span>
                                    <span class="information__text">{{service.price}}</span>
                                </div>
                            </div>
                            <div v-if="service.title === 'Иное гранитное изделие'">
                                <div class="information__item">
                                    <span class="information__title">Наименование услуги</span>
                                    <span class="information__text">{{service.title}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Название изделия</span>
                                    <span class="information__text">{{service.anotherMonument}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Размер</span>
                                    <span class="information__text">{{service.size}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Полировка</span>
                                    <span class="information__text">{{service.polish}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Цена</span>
                                    <span class="information__text">{{service.price}}</span>
                                </div>
                            </div>
                            <div v-if="service.title === 'Шрифт' || service.title === 'Пескоструйные изображения'">
                                <div class="information__item">
                                    <span class="information__title">Наименование услуги</span>
                                    <span class="information__text">{{service.title}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Номер в пескоструйном каталоге</span>
                                    <span class="information__text">{{service.sandblastingNumber}}</span>
                                </div>
                                <div v-if="service.title === 'Пескоструйные изображения'" class="information__item">
                                    <span class="information__title">Страница в пескоструйном каталоге</span>
                                    <span class="information__text">{{service.sandblastingPageNumber}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Количество</span>
                                    <span class="information__text">{{service.quantity}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Цена</span>
                                    <span class="information__text">{{service.price}}</span>
                                </div>
                            </div>
                            <div v-if="service.title === 'Крест' && service.type === 'Пескоструйные работы'">
                                <div class="information__item">
                                    <span class="information__title">Наименование услуги</span>
                                    <span class="information__text">{{service.title}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Номер в пескоструйном каталоге</span>
                                    <span class="information__text">{{service.sandblastingNumber}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Количество</span>
                                    <span class="information__text">{{service.quantity}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Цена</span>
                                    <span class="information__text">{{service.price}}</span>
                                </div>
                            </div>
                            <div v-if="service.title === 'Покраска'">
                                <div class="information__item">
                                    <span class="information__title">Наименование услуги</span>
                                    <span class="information__text">{{service.title}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Цвет</span>
                                    <span class="information__text">{{service.color}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Количество</span>
                                    <span class="information__text">{{service.quantity}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Цена</span>
                                    <span class="information__text">{{service.price}}</span>
                                </div>
                            </div>
                            <div v-if="service.title === 'Эпитафия'">
                                <div class="information__item">
                                    <span class="information__title">Наименование услуги</span>
                                    <span class="information__text">{{service.title}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Номер в каталоге / Иное</span>
                                    <span class="information__text">{{service.epitaph}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Количество</span>
                                    <span class="information__text">{{service.quantity}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Шрифт</span>
                                    <span class="information__text">{{service.font}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Цена</span>
                                    <span class="information__text">{{service.price}}</span>
                                </div>
                            </div>
                            <div v-if="service.title === 'Портрет'">
                                <div class="information__item">
                                    <span class="information__title">Наименование услуги</span>
                                    <span class="information__text">{{service.title}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Тип портрета</span>
                                    <span class="information__text">{{service.portrait}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Количество</span>
                                    <span class="information__text">{{service.quantity}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Цена</span>
                                    <span class="information__text">{{service.price}}</span>
                                </div>
                            </div>
                            <div v-if="service.title === 'Ретушь'">
                                <div class="information__item">
                                    <span class="information__title">Наименование услуги</span>
                                    <span class="information__text">{{service.title}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Тип ретуши</span>
                                    <span class="information__text">{{service.retouch}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Количество</span>
                                    <span class="information__text">{{service.quantity}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Цена</span>
                                    <span class="information__text">{{service.price}}</span>
                                </div>
                            </div>
                            <div v-if="service.title === 'Цветы' || service.title === 'Свечи' || service.title === 'Пейзаж'">
                                <div class="information__item">
                                    <span class="information__title">Наименование услуги</span>
                                    <span class="information__text">{{service.title}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Номер в художественном каталоге</span>
                                    <span class="information__text">{{service.artworkNumber}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Страница в художественном каталоге</span>
                                    <span class="information__text">{{service.artworkPageNumber}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Количество</span>
                                    <span class="information__text">{{service.quantity}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Цена</span>
                                    <span class="information__text">{{service.price}}</span>
                                </div>
                            </div>
                            <div v-if="service.title === 'Крест' && service.type === 'Художественные работы'">
                                <div class="information__item">
                                    <span class="information__title">Наименование услуги</span>
                                    <span class="information__text">{{service.title}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Номер в художественном каталоге</span>
                                    <span class="information__text">{{service.artworkNumber}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Страница в художественном каталоге</span>
                                    <span class="information__text">{{service.artworkPageNumber}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Количество</span>
                                    <span class="information__text">{{service.quantity}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Цена</span>
                                    <span class="information__text">{{service.price}}</span>
                                </div>
                            </div>
                            <div v-if="service.title === 'Иное изображение'">
                                <div class="information__item">
                                    <span class="information__title">Наименование услуги</span>
                                    <span class="information__text">{{service.title}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Название</span>
                                    <span class="information__text">{{service.anotherArtwork}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Количество</span>
                                    <span class="information__text">{{service.quantity}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Ретушь</span>
                                    <span class="information__text">{{service.anotherArtworkRetouch}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Цена</span>
                                    <span class="information__text">{{service.price}}</span>
                                </div>
                            </div>
                            <div v-if="service.title === 'Макет памятника'">
                                <div class="information__item">
                                    <span class="information__title">Наименование услуги</span>
                                    <span class="information__text">{{service.title}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Тип макета памятника</span>
                                    <span class="information__text">{{service.monumentModel}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Цена</span>
                                    <span class="information__text">{{service.price}}</span>
                                </div>
                            </div>
                            <div v-if="service.title === 'Керамогранит' || service.title === 'Металлофото' || service.title === 'Табличка эмаль \\ фото эмаль'">
                                <div class="information__item">
                                    <span class="information__title">Наименование услуги</span>
                                    <span class="information__text">{{service.title}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Размер</span>
                                    <span class="information__text">{{service.size}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Количество</span>
                                    <span class="information__text">{{service.quantity}}</span>
                                </div>
                                <div v-if="service.title === 'Табличка эмаль \\ фото эмаль'" class="information__item">
                                    <span class="information__title">Крепеж</span>
                                    <span class="information__text">{{service.fastener}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Цена</span>
                                    <span class="information__text">{{service.price}}</span>
                                </div>
                                <div v-if="service.title === 'Керамогранит'" class="information__item">
                                    <span class="information__title">Макет керамогранита</span>
                                    <span class="information__text">{{service.porcelainModel}}</span>
                                </div>
                                <div v-if="service.title === 'Металлофото'" class="information__item">
                                    <span class="information__title">Макет металлофото</span>
                                    <span class="information__text">{{service.metalPhoto}}</span>
                                </div>
                                <div v-if="service.title === 'Табличка эмаль \\ фото эмаль'" class="information__item">
                                    <span class="information__title">Макет эмали</span>
                                    <span class="information__text">{{service.enamelModel}}</span>
                                </div>
                                <div class="information__item">
                                    <span class="information__title">Цена за макет</span>
                                    <span class="information__text">{{service.modelPrice}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="service__summary">
                            <div class="service__summary_box">
                                <span class="service__summary_name">Итого: {{servicesType}}</span>
                                <span class="service__summary_sum">{{getCurrentTypePrice(servicesType)}} руб.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="order-information__item additional-service" v-if="orderInformation.moreServices">
                <h3 class="order-information__title_min">Дополнительные услуги</h3>
                <p class="additional-service__field info">{{orderInformation.moreServices}}</p>
            </div>
            <div class="order-information__item payment">
                <div class="col">
                    <div class="cost">
                        <h3 class="order-information__title_min">Расчёт стоимости</h3>
                        <div class="cost__list">
                            <div class="col">
                                <div class="payment__value-box">
                                    <span class="payment__label">Сумма заказа</span>
                                    <div class="payment__value payment__value_min">{{new Intl.NumberFormat('ru-RU').format(orderInformation.price.total)}} руб.</div>
                                </div>
                            </div>
                            <div class="col">
                                <div class="payment__value-box">
                                    <span class="payment__label">Тип оплаты</span>
                                    <div class="payment__value payment__value_min min">{{prepay === 0 ? 'без предоплаты' : remains === 0 ? 'полный расчёт' : 'авансовый платёж'}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="discount">
                        <div class="col">
                            <div class="payment__value-box">
                                <span class="payment__label">Скидка</span>
                                <div class="payment__value payment__value_min min">{{orderInformation.price.discountValue}} {{orderInformation.price.discountMeasure}}</div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="payment__value-box">
                                <span class="payment__label">Размер аванса</span>
                                <div class="payment__value payment__value_min min">{{new Intl.NumberFormat('ru-RU').format(prepay)}} руб.</div>
                            </div>
                        </div>
                    </div>
                    <div class="create-order__item pay">
                        <div class="col">
                            <div class="payment__value-box">
                                <span class="payment__label payment__label_big">К оплате</span>
                                <div class="payment__value payment__value_gold">{{new Intl.NumberFormat('ru-RU').format(orderInformation.price.final)}} руб.</div>
                            </div>
                            <div class="payment__value-box payment__value_mt">
                                <span v-if="orderInformation.payments[0]" class="payment__label">Способ оплаты</span>
                                <div class="payment__value payment__value_min min">{{orderInformation.payments[0]?.method}}</div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="payment__value-box">
                                <span class="payment__label">Остаток</span>
                                <div class="payment__value">{{new Intl.NumberFormat('ru-RU').format(orderInformation.price.final - prepay)}} руб.</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <h3 class="order-information__title_min">Сроки выполнения работ</h3>
                    <div class="order-information__date">
                        <div class="col" v-if="orderInformation.dates.startAt">
                            <div class="payment__value-box">
                                <span class="payment__label">Начало работ</span>
                                <div class="payment__value min">{{new Date(orderInformation.dates.startAt).toLocaleDateString()}}</div>
                            </div>
                        </div>
                        <div class="col" v-if="orderInformation.dates.endAt">
                            <div class="payment__value-box">
                                <span class="payment__label">Окончание работ</span>
                                <div class="payment__value min">{{new Date(orderInformation.dates.endAt).toLocaleDateString()}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="order-information__item order-information__comment" v-if="orderInformation.comment">
                        <div class="order-information__item additional-service">
                            <h3 class="order-information__title_min">Комментарий к заказу</h3>
                            <p class="additional-service__field info">{{orderInformation.comment}}</p>
                        </div>
                    </div>
                    <div class="order-information__item order-information__upload">
                        <div class="order-information__item additional-service uploaded-files">
                            <h3 class="order-information__title_min">Прикреплённые файлы</h3>
                            <button-component v-for="file, key in orderInformation.uploadFiles" :key="key" class="button image uploaded" :button-text=file.name @click="openImage = true; openPopup(key)"/>
                        </div>
                    </div>
                    <div class="order-information__item order-information__signature" v-if="orderInformation.signImage">
                        <h3 class="order-information__title_min">Подпись заказчика</h3>
                        <img :src="orderInformation.signImage" alt="" width="280" height="300">
                    </div>
                </div>
            </div>
        </div>
        <popup-component :mt="true" :isOpen="openImage === true" @close="openImage = false">
            <template #title>
                Фото
            </template>
            <template #content>
                <img class="upload-image" v-if="filePaths" :src="filePath" alt="image">
            </template>
        </popup-component>
    </div>
</template>
<script setup lang="ts">
import {onMounted, PropType, ref} from 'vue'
import router from '../app/router/router'
import { Order } from '../app/lib/types/orders'
import ButtonComponent from '../shared/buttonComponent.vue'
import PopupComponent from '../entities/popupComponent.vue'
import orderFileComponent from '../components/orderFileComponent.vue'
import {UserRole} from "../app/lib/types/users"

const props = defineProps({
    order: {
        type: Object as PropType<Order>,
        required: true
    }
})

const prepay =  props.order?.payments.reduce((sum, item) => {return sum + item.amount}, 0)

const remains: number | undefined = props.order?.price.final - prepay

const servicesTypes = ['Гранитное изделие', 'Пескоструйные работы', 'Художественные работы', 'Фото']

function getCurrentServiceType(type: string) {
    return props.order.services?.filter((item) => item.type === type)
}
function getCurrentTypePrice(type: string) {
    let price = 0
    getCurrentServiceType(type)?.forEach((item) => {
        price += item.price
    })
    return new Intl.NumberFormat('ru-RU').format(price)
}

let orderInformation: Order = props.order
const openImage = ref(false)
const filePaths = orderInformation.uploadFiles?.map((file) => import.meta.env.VITE_BACKEND + file.path)
let filePath = ''
const role = localStorage.getItem("role")

const openPopup = (key: number) => {
    filePaths !== undefined ? filePath = filePaths[key] : filePath = ''
}
</script>